import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import 'telstra-ui/resources/telstraui.css';
import 'telstra-ui/resources/themes/pacific.css';
import AppWrapper from '../../app-wrapper';
import Loader from '../../components/loader';
import AccountDetails from '../ngm-homepage/ngm-components/account_details/account_details';
import SummaryDetails from '../ssm-homepage/ssm-components/summary-details/summary-details';
import AutoSaveMessage from '../ssm-homepage/ssm-components/auto-save-message/auto-save-message';
import {
  stripStartingAndEndingPTags,
  prepareIsdnCallbackData,
  validateNumber,
  scrollElementIntoView,
} from '../ssm-homepage/ssm-homepage.actions';
import FloatingCta from '../../components/floating-cta';
import ServiceDetails from './sct-components/service-details/service-details';
import RequestCallBackModalOffline from '../ssm-homepage/ssm-components/request-callback-modal/request-callback-modal-offline';
import RequestCallBackModalOnline from '../ssm-homepage/ssm-components/request-callback-modal/request-callback-modal-online';
import { updateLiveChatValues, showHideOldNewHeaderFooter } from '../../app-actions';
import {
  AUTO_SAVE_TIMER_COUNT,
  AUTO_SAVE_STATUS_SAVING,
  DEBUG_MODE,
} from '../../app-constants';
import {
  createOptionsForAddressSearchInput,
  getSiteServiceDetails,
  prepareAutoSaveDataForSubmit,
  populateServiceQuantityDetails,
  updateSiteStatus,
  validatePhoneNumberWithStartLetter,
} from './sct-homepage.actions';
import SubmitSiteSection from './sct-components/submit-site-section/submit-site-section';
import SummaryBoxes from './sct-components/summary-boxes/summary-boxes';
import TotalsSection from './sct-components/totals-section/totals-section';
import './sct-homepage.css';

class SCTHomePageView extends Component {
  state = {
    modalIsOpen: false,
    formSubmittedLoader: false,
    callBackRequestLiveChatOfflineModalIsOpen: false,
    callBackRequestLiveChatOnlineModalIsOpen: false,
    callBackRequestCompleted: false,
    callBackPhoneNumber: '',
    IsCallBackPhoneNumberhasError: false,
    searchAddressData: [],
    optionsForSearchInput: [],
    selectedSiteAddress: ' ',
    siteServiceDetails: [],
    serviceQuantityDetails: {},
    estimatedTotalTipt: 0,
    estimatedTotalLiberate: 0,
    estimatedTotalSitesCosts: 0,
    selectedSiteId: -1,
    siteProcessed: {},
    dataSavedTime: null,
    currentPage: 0,
  };

  componentDidMount = () => {
    showHideOldNewHeaderFooter(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataLoaded !== this.props.dataLoaded && this.props.dataLoaded && this.props.formSubmitted === false) {
      this.setCallbackPhonenumber(this.props.customerContactPhone);
      updateLiveChatValues(this.props.authorableContent.liveChat, 'SCT');
      this.updateSiteAddressData(
        createOptionsForAddressSearchInput(this.props.sitesData),
        populateServiceQuantityDetails(this.props.sitesData),
      );
      this.setupAutoSaveTimer();
      setTimeout(() => this.selectInitialAddress('0'), 500);
    }
  }

  onAutoSaveHandler = () => {
    const { submitSCTAutoSave } = this.props.actions;
    const { autoSaveStatus } = this.props;
    const isSiteProcessed = this.state.siteProcessed[this.state.selectedSiteId] !== undefined;
    if (isSiteProcessed === true && autoSaveStatus !== AUTO_SAVE_STATUS_SAVING) {
      if (DEBUG_MODE) {
        console.log('auto save starting'); // eslint-disable-line
      }
      const authorableData = {
        migrateTiptCost: this.props.authorableContent.serviceOverview.tiptServiceCost,
        migrateToLiberateCost: this.props.authorableContent.serviceOverview.liberateServiceCost,
      };
      const dataForSubmit = prepareAutoSaveDataForSubmit(this.props.sitesData,
        this.state.selectedSiteId, this.state.serviceQuantityDetails, authorableData);
      this.markSiteUnProcessed(this.state.selectedSiteId);
      submitSCTAutoSave(dataForSubmit);
    }
  }

  onOpenRequestCallBack = () => {
    const isLiveChatAgentPresent = document.querySelector('.embeddedServiceHelpButton .helpButton .uiButton.helpButtonEnabled');
    if (isLiveChatAgentPresent) {
      this.setState({ callBackRequestLiveChatOnlineModalIsOpen: true });
    } else {
      this.setState({ callBackRequestLiveChatOfflineModalIsOpen: true });
    }
  }

  onOnlineRequestCallBack = () => {
    this.setState({ callBackRequestLiveChatOnlineModalIsOpen: false, callBackRequestLiveChatOfflineModalIsOpen: true });
  }


  onCloseRequestCallBackOffline = () => {
    const originalCallBackNumber = this.props.customerContactPhone;
    this.setState({ callBackRequestLiveChatOfflineModalIsOpen: false,
      callBackRequestCompleted: false,
      callBackPhoneNumber: originalCallBackNumber,
      IsCallBackPhoneNumberhasError: false,
    });
    setTimeout(() => { scrollElementIntoView('root'); }, 200);
  }

  onPageChangeHandler = (pageNumber) => {
    this.setState({ currentPage: pageNumber }, () => {
      scrollElementIntoView('site-address-search-dropdown-container');
    });
  }

  onStartLiveChat = () => {
    this.setState({ callBackRequestLiveChatOfflineModalIsOpen: false,
      callBackRequestLiveChatOnlineModalIsOpen: false,
      callBackRequestCompleted: false });
    const liveChatButton = document.querySelector('.embeddedServiceHelpButton .helpButton .uiButton.helpButtonEnabled');
    liveChatButton.click();
  }


  onServiceQuanitityChange = (index, value) => {
    const siteId = index.split('-')[0];
    const quantityData = this.state.serviceQuantityDetails;
    const TIPTserviceCost = parseInt(this.props.authorableContent.serviceOverview.tiptServiceCost, 10);
    const LiberateserviceCost = parseInt(this.props.authorableContent.serviceOverview.liberateServiceCost, 10);
    let estimatedTotalTipt = 0;
    let estimatedTotalLiberate = 0;
    quantityData[index] = value;

    let estimatedTotalSitesCosts = 0;

    Object.entries(quantityData).forEach((entry) => {
      const [key, dataValue] = entry;
      if (key.includes('tipt')) {
        estimatedTotalSitesCosts += dataValue * parseInt(this.props.authorableContent.serviceOverview.tiptServiceCost, 10);
      } else if (key.includes('liberate')) {
        estimatedTotalSitesCosts += dataValue * parseInt(this.props.authorableContent.serviceOverview.liberateServiceCost, 10);
      }
    });

    Object.keys(quantityData).forEach((type) => {
      if (type.split('-')[2] === 'tipt' && parseInt(type.split('-')[0], 10) === this.state.selectedSiteId) {
        estimatedTotalTipt += quantityData[type] * TIPTserviceCost;
      } else if (type.split('-')[2] === 'liberate' && parseInt(type.split('-')[0], 10) === this.state.selectedSiteId) {
        estimatedTotalLiberate += quantityData[type] * LiberateserviceCost;
      }
    });

    const siteAddressAndStatusData = updateSiteStatus(this.state.searchAddressData, this.state.selectedSiteId);
    const selectedSite = siteAddressAndStatusData.find(address => address.itemId === parseInt(this.state.selectedSiteId, 10));
    this.setState({
      serviceQuantityDetails: quantityData,
      estimatedTotalSitesCosts,
      estimatedTotalTipt,
      estimatedTotalLiberate,
      searchAddressData: siteAddressAndStatusData,
      optionsForSearchInput: siteAddressAndStatusData,
      selectedSiteAddress: selectedSite.displayText,
    });
    this.markSiteProcessed(siteId);
  }

  onRequestCallBackCompleted = () => {
    const { submitSCTRequestCallback } = this.props.actions;
    const { callBackPhoneNumber } = this.state;
    const { customerContactPhone } = this.props;
    const callBackData = prepareIsdnCallbackData(customerContactPhone !== callBackPhoneNumber ? callBackPhoneNumber : '');
    this.setState({ callBackRequestCompleted: true });
    const authorableData = {
      migrateTiptCost: this.props.authorableContent.serviceOverview.tiptServiceCost,
      migrateToLiberateCost: this.props.authorableContent.serviceOverview.liberateServiceCost,
    };
    const dataForSubmit = prepareAutoSaveDataForSubmit(this.props.sitesData,
      this.state.selectedSiteId, this.state.serviceQuantityDetails, authorableData);
    dataForSubmit.sitesData.status = 'Reviewed';
    dataForSubmit.alternateContactNumber = callBackData.alternateContactNumber;
    submitSCTRequestCallback(dataForSubmit);
  }

  setCallbackPhonenumber = (phoneNumber) => {
    const callBackPhoneNumber = this.state.callBackPhoneNumber || phoneNumber;
    this.setState({ callBackPhoneNumber });
  }

  setupAutoSaveTimer = () => {
    const timeInMilliSeconds = parseInt(AUTO_SAVE_TIMER_COUNT, 10) * 60 * 1000;
    setInterval(() => {
      this.onAutoSaveHandler();
    }, timeInMilliSeconds);
  }

  markSiteProcessed = (siteId) => {
    const siteProcessed = this.state.siteProcessed;
    if (siteId.length > 0 && siteProcessed[siteId] === undefined) {
      siteProcessed[siteId] = true;
      setTimeout(() => {
        this.setState({ siteProcessed });
      }, 500);
    }
  };

  markSiteUnProcessed = (siteId) => {
    const siteProcessed = this.state.siteProcessed;
    delete siteProcessed[siteId];
    const newDataSaveTime = new Date();
    setTimeout(() => {
      this.setState({ siteProcessed, dataSavedTime: newDataSaveTime });
    }, 500);
  };

  handleCallbackPhoneNumberOnChange = (event) => {
    let callBackPhoneNumber = this.state.callBackPhoneNumber || '';
    if (event.target.value.length < 11 && validateNumber(event.target.value)) {
      callBackPhoneNumber = event.target.value;
      let phoneError = false;
      if (callBackPhoneNumber.length === 10) {
        phoneError = !validatePhoneNumberWithStartLetter(callBackPhoneNumber);
      }
      this.setState({ callBackPhoneNumber, IsCallBackPhoneNumberhasError: phoneError });
    }
  }

  handleCallbackPhoneNumberOnBlur = (event) => {
    let IsCallBackPhoneNumberhasError = this.state.IsCallBackPhoneNumberhasError || false;
    IsCallBackPhoneNumberhasError = !validatePhoneNumberWithStartLetter(event.target.value) || event.target.value.length !== 10;
    this.setState({ IsCallBackPhoneNumberhasError });
  }

  updateSiteAddressData = (siteAddressDetails, quantityDetails) => {
    let estimatedTotalTipt = 0;
    let estimatedTotalLiberate = 0;
    let estimatedTotalSitesCosts = 0;
    const TIPTserviceCost = parseInt(this.props.authorableContent.serviceOverview.tiptServiceCost, 10);
    const LiberateserviceCost = parseInt(this.props.authorableContent.serviceOverview.liberateServiceCost, 10);


    Object.entries(quantityDetails).forEach((entry) => {
      const [key, dataValue] = entry;
      if (key.includes('tipt')) {
        estimatedTotalSitesCosts += dataValue * parseInt(this.props.authorableContent.serviceOverview.tiptServiceCost, 10);
      } else if (key.includes('liberate')) {
        estimatedTotalSitesCosts += dataValue * parseInt(this.props.authorableContent.serviceOverview.liberateServiceCost, 10);
      }
    });

    Object.keys(quantityDetails).forEach((type) => {
      if (type.split('-')[2] === 'tipt' && parseInt(type.split('-')[0], 10) === this.state.selectedSiteId) {
        estimatedTotalTipt += quantityDetails[type] * TIPTserviceCost;
      } else if (type.split('-')[2] === 'liberate' && parseInt(type.split('-')[0], 10) === this.state.selectedSiteId) {
        estimatedTotalLiberate += quantityDetails[type] * LiberateserviceCost;
      }
    });

    this.setState({
      searchAddressData: siteAddressDetails,
      optionsForSearchInput: siteAddressDetails,
      serviceQuantityDetails: quantityDetails,
      estimatedTotalSitesCosts,
      estimatedTotalTipt,
      estimatedTotalLiberate,
    });
  }

  searchSiteAddress = (event) => {
    const searchText = event.target.value;
    const options = this.state.optionsForSearchInput.filter((option) => {
      const match = option.displayText.toLowerCase().match(searchText.toLowerCase());
      if (match != null && match.index !== undefined) {
        return true;
      }
      return false;
    });
    this.setState({ searchAddressData: options });
  }

  selectAddressOption = (event) => {
    this.onAutoSaveHandler();
    const selectedSiteId = event.target.getAttribute('data-item');
    const selectedSite = this.state.searchAddressData.find(address => address.itemId === parseInt(selectedSiteId, 10));
    const siteServiceDetails = getSiteServiceDetails(this.props.sitesData, parseInt(selectedSiteId, 10));

    const quantityData = this.state.serviceQuantityDetails;

    let estimatedTotalTipt = 0;
    let estimatedTotalLiberate = 0;
    const TIPTserviceCost = parseInt(this.props.authorableContent.serviceOverview.tiptServiceCost, 10);
    const LiberateserviceCost = parseInt(this.props.authorableContent.serviceOverview.liberateServiceCost, 10);


    Object.keys(quantityData).forEach((type) => {
      if (type.split('-')[2] === 'tipt' && type.split('-')[0] === selectedSiteId) {
        estimatedTotalTipt += quantityData[type] * TIPTserviceCost;
      } else if (type.split('-')[2] === 'liberate' && type.split('-')[0] === selectedSiteId) {
        estimatedTotalLiberate += quantityData[type] * LiberateserviceCost;
      }
    });

    this.setState({
      selectedSiteAddress: selectedSite.displayText,
      siteServiceDetails,
      selectedSiteId: parseInt(selectedSiteId, 10),
      estimatedTotalTipt,
      estimatedTotalLiberate,
      currentPage: 0,
    });
  }

  selectInitialAddress = (selectedSiteId) => {
    const selectedSite = this.state.searchAddressData.find(address => address.itemId === parseInt(selectedSiteId, 10));
    const siteServiceDetails = getSiteServiceDetails(this.props.sitesData, parseInt(selectedSiteId, 10));

    const quantityData = this.state.serviceQuantityDetails;

    let estimatedTotalTipt = 0;
    let estimatedTotalLiberate = 0;
    const TIPTserviceCost = parseInt(this.props.authorableContent.serviceOverview.tiptServiceCost, 10);
    const LiberateserviceCost = parseInt(this.props.authorableContent.serviceOverview.liberateServiceCost, 10);


    Object.keys(quantityData).forEach((type) => {
      if (type.split('-')[2] === 'tipt' && type.split('-')[0] === selectedSiteId) {
        estimatedTotalTipt += quantityData[type] * TIPTserviceCost;
      } else if (type.split('-')[2] === 'liberate' && type.split('-')[0] === selectedSiteId) {
        estimatedTotalLiberate += quantityData[type] * LiberateserviceCost;
      }
    });

    this.setState({
      selectedSiteAddress: selectedSite.displayText,
      siteServiceDetails,
      selectedSiteId: parseInt(selectedSiteId, 10),
      estimatedTotalTipt,
      estimatedTotalLiberate,
      currentPage: 0,
    });
  }

  render() {
    if (this.props.dataLoaded && this.props.formSubmitted === false) {
      const {
        sct: {
          title: pageTitle,
          description,
          alreadySubmittedBanner,
        },
        confirmDetails: {
          accountNameText,
        },
        requestCallBack: {
          requestCallBackModal: {
            title: requestCallbackOfflineTitle,
            text: requestCallbackOfflineText,
            yesText: requestCallbackOfflineYesText,
            formFields: requestCallbackOfflineFormfields,
          },
          thankYouModal: {
            title: callbackThankYouTitle,
            text: callbackThankYouText,
          },
          floatingCtaCallBack: {
            icon: callbackIcon,
            text: callbackText,
          },
          liveChatModal: {
            title: liveChatModalTitle,
            text: liveChatModalText,
            callbackText: callBackButtontext,
            chatNowText: chatNowButtonText,
          },

        },
        serviceOverview,
        serviceOverview: {
          heading: serviceHeading,
          description: serviceDescription,
          siteAddress,
          autoSaveInitiateText,
          autoSaveInProcessText,
          autoSaveCompletedText,
          autoSaveInitiateToolTipText,
          autoSaveInProcessToolTipText,
          autoSaveCompletedToolTipText,
          saveNowButtonText,
          callbackNumberEmptyText,
        },
        submitSection: {
          headingText: submitHeading,
          descriptionText: submitDescription,
          submitButtonText,
          submitButtonDescriptionText,
        },
      } = this.props.authorableContent;

      const {
        customerAccountName,
        autoSaveStatus,
        alreadySubmitted,
        alreadySubmittedDate,
      } = this.props;

      const callbackCta = [
        {
          icon: callbackIcon,
          text: callbackText,
          onCtaClick: () => {
            this.onOpenRequestCallBack();
          },
        },
      ];

      const { callBackPhoneNumber } = this.state;

      const requestCallBackOfflineAuthorableContent = {
        requestCallbackOfflineTitle,
        requestCallbackOfflineText: callBackPhoneNumber.length > 0 ? requestCallbackOfflineText : callbackNumberEmptyText,
        requestCallbackOfflineYesText,
        requestCallbackOfflineFormfields,
        callbackThankYouTitle,
        callbackThankYouText,
        callbackNumberEmptyText,
      };

      const requestCallBackLiveChatOnlineAuthorableContent = {
        liveChatModalTitle,
        liveChatModalText,
        callBackButtontext,
        chatNowButtonText,
        callbackThankYouTitle,
        callbackThankYouText,
      };
      const serviceTermAuthorableContent = {
        autoSaveInitiateText,
        autoSaveInProcessText,
        autoSaveCompletedText,
        autoSaveInitiateToolTipText,
        autoSaveInProcessToolTipText,
        autoSaveCompletedToolTipText,
        saveNowButtonText,
      };
      const alreadySubmittedDescription = `${alreadySubmittedBanner} ${alreadySubmittedDate}`;

      let totalTiptCost = 0;
      let totalLiberateCost = 0;
      let totalTiptUsers = 0;
      let totalLiberateUsers = 0;
      const quantityData = this.state.serviceQuantityDetails;
      const TIPTserviceCost = parseInt(this.props.authorableContent.serviceOverview.tiptServiceCost, 10);
      const LiberateserviceCost = parseInt(this.props.authorableContent.serviceOverview.liberateServiceCost, 10);

      Object.keys(quantityData).forEach((type) => {
        if (type.split('-')[2] === 'tipt') {
          totalTiptCost += quantityData[type] * TIPTserviceCost;
          totalTiptUsers += quantityData[type];
        } else if (type.split('-')[2] === 'liberate') {
          totalLiberateCost += quantityData[type] * LiberateserviceCost;
          totalLiberateUsers += quantityData[type];
        }
      });
      // const totalSectionsAuthorableContent = {
      //   estimatedCostAllSitesText,
      //   usersText,
      //   costText,
      //   usersToTipt,
      //   usersToLiberate,
      //   perMonthTotalText,
      //   totalText,
      // }

      return (
        <AppWrapper>
          <div className="sct-homepage root-container container">
            <AccountDetails
              accountNameText={accountNameText}
              customerAccountName={customerAccountName}
            />
            {alreadySubmitted &&
              <GenericAlert
                name="primary-title"
                description={alreadySubmittedDescription}
                showBackground
              />
            }
            <SummaryDetails
              summaryTitle={pageTitle}
              summaryText={stripStartingAndEndingPTags(description)}
              customHeadingClass="heading40"
              customDescriptionClass="body18"
            />
            <div className="service-over-view-section" id="service-over-view-section">
              <SummaryDetails
                summaryTitle={serviceHeading}
                summaryText={stripStartingAndEndingPTags(serviceDescription)}
                customHeadingClass="heading34"
                customDescriptionClass="body18"
              />
              <Dropdown
                dropdownId="site-address-search-dropdown"
                label={siteAddress}
                value={this.state.selectedSiteAddress}
                searchOnChange={this.searchSiteAddress}
                searchBox
                highlightSelected
                options={this.state.searchAddressData}
                onOptionClick={this.selectAddressOption}
              />
            </div>

            {this.state.selectedSiteAddress.length > 5 &&
              <React.Fragment>
                <ServiceDetails
                  authorableContent={serviceOverview}
                  handleServiceQuanitityChange={this.onServiceQuanitityChange}
                  siteServiceDetails={this.state.siteServiceDetails}
                  quantityData={this.state.serviceQuantityDetails}
                  siteId={this.state.selectedSiteId}
                  currentPage={this.state.currentPage}
                  pageChangeHandler={this.onPageChangeHandler}
                />
                <SummaryBoxes
                  authorableContent={serviceOverview}
                  tiptCost={this.state.estimatedTotalTipt}
                  liberateCost={this.state.estimatedTotalLiberate}
                  allSitesCost={this.state.estimatedTotalSitesCosts}
                />
                <TotalsSection
                  authorableContent={serviceOverview}
                  tiptCost={totalTiptCost}
                  liberateCost={totalLiberateCost}
                  allSitesCost={this.state.estimatedTotalSitesCosts}
                  tiptUsers={totalTiptUsers}
                  liberateUsers={totalLiberateUsers}
                  allSitesUsers={totalTiptUsers + totalLiberateUsers}
                />
              </React.Fragment>
            }
            <div className="submit-section">
              <SummaryDetails
                summaryTitle={submitHeading}
                summaryText={stripStartingAndEndingPTags(submitDescription)}
                customHeadingClass="heading34"
                customDescriptionClass="body18"
              />
              <SubmitSiteSection
                submitButtonText={submitButtonText}
                description={renderHTML(stripStartingAndEndingPTags(submitButtonDescriptionText))}
                onSubmitSiteConfirmButton={this.onOpenRequestCallBack}
              />
            </div>
            <FloatingCta ctas={callbackCta} />
            <RequestCallBackModalOffline
              customerContactPhone={this.state.callBackPhoneNumber}
              modalIsOpen={this.state.callBackRequestLiveChatOfflineModalIsOpen}
              onCloseDialogBox={this.onCloseRequestCallBackOffline}
              onRequestCallback={this.onRequestCallBackCompleted}
              authorableContent={requestCallBackOfflineAuthorableContent}
              callBackRequestCompleted={this.state.callBackRequestCompleted}
              IsCallBackPhoneNumberhasError={this.state.IsCallBackPhoneNumberhasError}
              onBlur={this.handleCallbackPhoneNumberOnBlur}
              onChange={this.handleCallbackPhoneNumberOnChange}
            />
            <RequestCallBackModalOnline
              modalIsOpen={this.state.callBackRequestLiveChatOnlineModalIsOpen}
              onCloseDialogBox={this.onCloseRequestCallBackOffline}
              onRequestCallback={this.onOnlineRequestCallBack}
              onStartLiveChat={this.onStartLiveChat}
              authorableContent={requestCallBackLiveChatOnlineAuthorableContent}
              callBackRequestCompleted={this.state.callBackRequestCompleted}
            />
            <AutoSaveMessage
              message={autoSaveStatus}
              serviceTermAuthorableContent={serviceTermAuthorableContent}
              saveNowClickHandler={this.onAutoSaveHandler}
              dataSavedTime={this.state.dataSavedTime}
            />


          </div>
        </AppWrapper>
      );
    }
    return <Loader />;
  }
}
export default SCTHomePageView;
